<template>
  <div class="zj-moble-app-page">
    <mt-header class="zj-mt-header" fixed="true" slot="left">
      <mt-button slot="left" class="nav-btn">任务详情</mt-button>
    </mt-header>
    <div class="zj-mt-content">
      <div class="zj-mt-map">
        <ZJMobileApp :point="point"></ZJMobileApp>
      </div>
      <div class="zj-mt-taskinfo">
        <mt-cell title="任务详情：" :label="Task.title">
          <img class="iconLeft" slot="icon" src="../images/icon1.png" />
        </mt-cell>
        <mt-cell title="任务描述：" :label="Task.taskContent">
          <img class="iconLeft" slot="icon" src="../images/icon2.png" />
        </mt-cell>
        <mt-cell title="任务地址：" :label="Task.address">
          <img class="iconLeft" slot="icon" src="../images/icon3.png" />
        </mt-cell>
        <mt-cell title="负责人：" :label="Task.receiveUser">
          <img class="iconLeft" slot="icon" src="../images/icon4.png" />
        </mt-cell>
      </div>
    </div>
    <div class="zj-mt-footer" v-if="!Finshed">
      <mt-button
        type="primary"
        class="btnsubmit"
        @click.native="IsVisible = true"
        size="large"
        style="font-size: 30px"
        ><span style="font-size: 0.34rem">{{ finishDesc }}</span>
      </mt-button>
    </div>
    <mt-popup v-model="IsVisible" position="bottom" class="mint-popup">
      <mt-header title="任务反馈"></mt-header>
      <!-- <div class="filed-label">执行状态</div>
      <div class="filed-label">
        <mt-button
          size="small"
          :class="{ active: Finshed }"
          @click.native="OnExecStatusChanged('1')"
          >已完成</mt-button
        >
        <mt-button
          size="small"
          :class="{ active: Unfinished }"
          @click.native="OnExecStatusChanged('0')"
          >未完成</mt-button
        >
      </div> -->
      <div class="filed-label"><span style="color: red">*</span>反馈内容</div>
      <mt-field
        label
        placeholder="填写任务执行情况的说明"
        type="textarea"
        rows="4"
        v-model="Feed.finishIntro"
      ></mt-field>

      <div class="filed-label">图片</div>
      <nutimagepicker
        :imgList.sync="imgList"
        delMode="longtap"
        longTapTime="1000"
      ></nutimagepicker>

      <div class="filed-label">短视频</div>
      <nutvideopicker
        :imgList.sync="videoList"
        accept="video/*"
        delMode="longtap"
        longTapTime="1000"
      ></nutvideopicker>
      <mt-button
        class="popup-submit"
        type="primary"
        size="large"
        @click.native="submitFeedback"
        >提交</mt-button
      >
    </mt-popup>
  </div>
</template>

<script>
import Vue from "vue";
import { Field, Cell, Toast, Indicator } from "mint-ui";
Vue.component(Field.name, Field);
Vue.component(Cell.name, Cell);
import ZJMobileApp from "./component/map.vue";
import {
  getAPPIntegratedTaskById,
  finishIntegratedTask,
} from "@/api/src/integratedTask";
import nutimagepicker from "../../../components/imagepicker/imagepicker.vue";
import "../../../components/imagepicker/imagepicker.scss";
import nutvideopicker from "../../../components/imagepicker/videopicker.vue";
import "../../../components/imagepicker/videopicker.scss";
import { uploadFile } from "@/api/src/file";

export default {
  name: "MobileTaskCenter",
  controller: "UI",
  action: "MobileTaskCenter",
  components: {
    ZJMobileApp,
    nutimagepicker,
    nutvideopicker,
  },
  data: function () {
    return {
      Task: {},
      Feed: {},
      Finshed: true,
      Unfinished: false,
      IsVisible: false,
      imgList: [],
      videoList: [],
      fileList: [],
      finishDesc: "已完成，去反馈",

      point: [],
    };
  },
  created() {
    this.GetTask();
  },
  methods: {
    GetTask() {
      Indicator.open("加载中...");
      getAPPIntegratedTaskById(this.$route.query.ExecutTaskId).then((res) => {
        this.Task = res.data;
        if (res.data.status == "1") {
          this.Finshed = true;

          this.finishDesc = "反馈详情";
        } else {
          this.Finshed = false;
          this.finishDesc = "已完成，去反馈";
        }
        if (res.data.longitude && res.data.latitude) {
          this.point = [res.data.longitude, res.data.latitude];
        }

        Indicator.close();
      });
    },
    OnExecStatusChanged(val) {
      this.Feed.status = val;
      this.Finshed = val == 1;
      this.Unfinished = val == 0;
    },
    submitFeedback() {
      if (!this.Feed.finishIntro) {
        Toast({ message: "请填写任务执行情况的说明" });
        return false;
      }
      // 提交反馈数据
      this.Feed.id = this.$route.query.ExecutTaskId;
      this.Feed.status = "1";
      let that = this;
      if (this.imgList.length > 0 || this.videoList.length > 0) {
        that.uploadFile().then(() => {
          that.Feed.uploadResource = that.fileList.join(",");
          finishIntegratedTask(that.Feed).then((res) => {
            if (res.code == 200) {
              Toast({ message: "反馈成功" });
              this.IsVisible = false;
            } else {
              Toast({ message: "反馈失败" });
            }
          });
        });
      } else {
        finishIntegratedTask(this.Feed).then((res) => {
          if (res.code == 200) {
            this.IsVisible = false;
          }
        });
      }
    },
    // 上传文件
    uploadFile() {
      const that = this;
      return new Promise((resolve, reject) => {
        let mediaList = [].concat(that.imgList, that.videoList);
        var arr = [];

        mediaList.forEach((item) => {
          var formdata = new FormData();
          formdata.append("file", item.file);

          arr.push(this.upload(formdata));
        });

        ZJApp.ZJUtils.waitAll(arr)
          .then((r) => {
            resolve(r);
          })
          .catch((e) => {
            reject(e);
          });
      });
    },
    upload(formdata) {
      return uploadFile(formdata)
        .then((r) => {
          if (r.code == 200 && r.data) {
            let data = r.data;
            this.fileList.push(data);
          }
        })
        .catch((e) => {
          console.log(e);
          //this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.iconLeft {
  width: 0.54rem;
  height: 0.72rem;
}
.btnsubmit {
  font-size: 0.28rem;
}
</style>